var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7917 1.04169H5.20833C3.82751 1.04334 2.50371 1.59261 1.52731 2.569C0.550919 3.54539 0.00165402 4.86919 0 6.25002L0 18.75C0.00165402 20.1308 0.550919 21.4547 1.52731 22.431C2.50371 23.4074 3.82751 23.9567 5.20833 23.9584H19.7917C21.1725 23.9567 22.4963 23.4074 23.4727 22.431C24.4491 21.4547 24.9983 20.1308 25 18.75V6.25002C24.9983 4.86919 24.4491 3.54539 23.4727 2.569C22.4963 1.59261 21.1725 1.04334 19.7917 1.04169ZM5.20833 3.12502H19.7917C20.4154 3.12625 21.0245 3.3141 21.5406 3.6644C22.0567 4.0147 22.4561 4.51142 22.6875 5.09065L14.7104 13.0688C14.1234 13.6535 13.3286 13.9818 12.5 13.9818C11.6714 13.9818 10.8766 13.6535 10.2896 13.0688L2.3125 5.09065C2.5439 4.51142 2.94335 4.0147 3.45942 3.6644C3.9755 3.3141 4.5846 3.12625 5.20833 3.12502ZM19.7917 21.875H5.20833C4.37953 21.875 3.58468 21.5458 2.99862 20.9597C2.41257 20.3737 2.08333 19.5788 2.08333 18.75V7.81252L8.81667 14.5417C9.7944 15.517 11.119 16.0646 12.5 16.0646C13.881 16.0646 15.2056 15.517 16.1833 14.5417L22.9167 7.81252V18.75C22.9167 19.5788 22.5874 20.3737 22.0014 20.9597C21.4153 21.5458 20.6205 21.875 19.7917 21.875Z",
    fill: "#7131FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.f8626b00936bb946213ff8490e66e11f.svg";
export { ForwardRef as ReactComponent };